import { StylesIndexInjections } from 'common-react';
import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { CardProps } from './tools/Card.model';

// Padding configuration for different card variants
const cardPaddingConfig = {
  small: {
    desktop: {
      normal: '26px 28px',
      flat: '26px 0'
    },
    mobile: 20
  },
  big: {
    desktop: {
      normal: '32px',
      flat: '32px 0'
    },
    mobile: '24px 16px'
  },
  equal: {
    desktop: {
      normal: '24px',
      flat: '24px 0'
    },
    mobile: '16px'
  }
};

// Border properties configuration for each direction
const cardBorderConfig = {
  left: {
    width: 4,
    height: '100%',
    top: 0,
    bottom: 'auto',
    left: 0
  },
  top: {
    width: '100%',
    height: 4,
    top: 0,
    bottom: 'auto',
    left: 0
  },
  bottom: {
    width: '100%',
    height: 4,
    top: 'auto',
    bottom: 0,
    left: 0
  }
};

const getBasePadding = (props: CardProps) => cardPaddingConfig[props.size!].desktop[props.layout!];


const getMobilePadding = (props: CardProps, appPadding: number | string) => {
  if (props.fullWidth) {
    return appPadding;
  }
  return cardPaddingConfig[props.size!].mobile;
};

const getBorderValue = (property: keyof typeof cardBorderConfig.left, props: CardProps) => {
  if (!props.borderDirection) {
    return undefined;
  }
  return cardBorderConfig[props.borderDirection][property];
};

const getBackgroundColor = (type: CardProps['type'], theme: Theme) => {
  switch (type) {
    case 'ghost':
      return theme.color.greys[10];
    case 'dark':
      return theme.color.greys[80];
    case 'lightBlue':
      return theme.color.blues[10];
    default:
      return theme.color.greys[0];
  }
};

export default makeUiStyles((theme: Theme) => createStyles({
  card: {
    position: 'relative',
    background: ({type}:CardProps) => getBackgroundColor(type, theme),
    padding: (props:CardProps) => getBasePadding(props),
    borderRadius: 16,
    [theme.breakpoints.down('xs')]: {
      boxShadow: 'none',
      marginLeft: ({fullWidth}:CardProps) => fullWidth ? -theme.space.appPadding : 0,
      marginRight: ({fullWidth}:CardProps) => fullWidth ? -theme.space.appPadding : 0,
      padding: (props:CardProps) => getMobilePadding(props, theme.space.appPadding),
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      display: (props:CardProps) => props.borderColor ? 'block' : 'none',
      width: (props:CardProps) => getBorderValue('width', props),
      height: (props:CardProps) => getBorderValue('height', props),
      top: (props:CardProps) => getBorderValue('top', props),
      bottom: (props:CardProps) => getBorderValue('bottom', props),
      left: (props:CardProps) => getBorderValue('left', props),
      backgroundColor: (props:CardProps) => props.borderColor,
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        height: 4
      }
    },
  },
  hoverable: {
    transition: 'box-shadow 0.150s ease-in-out',
    '&:hover': {
      boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.15)',
    }
  }
}), { name: 'Card', index: StylesIndexInjections.UI_MOLECULES });
